import type { NAuth } from '@app/types/Auth';

export type WithActiveBranchId<T = {}> = T & {
  ActiveBranchId: NAuth.UserPrint['activeBranchId'];
};
